import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../context/authContext';
import styles from './Header.module.css';

const Header = () => {
  const { isLoggedIn, user, logout, language } = useContext(AuthContext);
  const [panelVisible, setPanelVisible] = useState(false);
  const togglePanel = () => setPanelVisible((prev) => !prev);
  const handleLogout = () => {
    logout();
    setPanelVisible(false);
  };

  // Localized labels
  const t = {
    home: language === 'zh' ? '主页' : 'Home',
    selfie: language === 'zh' ? '自拍' : 'Self-Shot',
    experimental: language === 'zh' ? '实验版' : 'Experimental',
    upload: language === 'zh' ? '上传' : 'Upload',
    profile: language === 'zh' ? '个人资料' : 'Profile',
    login: language === 'zh' ? '登录' : 'Login',
    signup: language === 'zh' ? '注册' : 'Sign Up',
    logout: language === 'zh' ? '退出' : 'Logout',
    menu: language === 'zh' ? '菜单' : 'Menu',
  };

  return (
    <header className={styles.mainHeader}>
      <div className={styles.headerContainer}>
        {/* Logo */}
        <Link to="/" >
          <div className={styles.logo}>
            <h1>W2Porn</h1>
          </div>
        </Link>

        {/* Category Nav */}
        <nav className={styles.categoryNav}>
          <Link to="/" className={styles.bigScreenOnly}>{t.home}</Link>
          <Link to="/selfieVideos" className={styles.experimentLink}>
            {t.selfie} <span className={styles.badge}>{t.experimental}</span>
          </Link>
          <Link to="/upload-movie" className={styles.bigScreenOnly}>{t.upload}</Link>
        </nav>

        {/* Toggle Button */}
        <button
          className={styles.headerToggle}
          onClick={togglePanel}
          aria-label="Toggle panel"
        >
          {isLoggedIn ? (
            <span
              className={`${styles.bigScreenOnly} ${styles.username}`}
              title={user?.username}
            >
              {user?.username}
            </span>
          ) : (
            <span className={styles.bigScreenOnly}>{t.menu}</span>
          )}
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <rect x="2" y="4" width="20" height="16" rx="2" ry="2" stroke="currentColor" strokeWidth="2" />
            <line x1="2" y1="10" x2="22" y2="10" stroke="currentColor" strokeWidth="2" />
            <line x1="2" y1="16" x2="22" y2="16" stroke="currentColor" strokeWidth="2" />
          </svg>
        </button>
      </div>

      {/* Auth Panel (mobile) */}
      {panelVisible && (
        <div className={styles.authPanel}>
          <Link to="/" className={styles.smallScreenOnly} onClick={() => setPanelVisible(false)}>
            {t.home}
          </Link>
          <Link to="/upload-movie" className={styles.smallScreenOnly} onClick={() => setPanelVisible(false)}>
            {t.upload}
          </Link>
          {isLoggedIn ? (
            <>
              <Link
                to={`/profile/${user._id}`}
                className={`${styles.authBtn} ${styles.login}`}
                onClick={() => setPanelVisible(false)}
              >
                {t.profile}
              </Link>
              <button className={styles.logoutButton} onClick={handleLogout}>
                {t.logout}
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                className={`${styles.authBtn} ${styles.login}`}
                onClick={() => setPanelVisible(false)}
              >
                {t.login}
              </Link>
              <Link
                to="/register"
                className={`${styles.authBtn} ${styles.signup}`}
                onClick={() => setPanelVisible(false)}
              >
                {t.signup}
              </Link>
            </>
          )}
        </div>
      )}
    </header>
  );
};

export default Header;
